var NotifyService = (function () {
    function NotifyService($mdToast) {
        this.$mdToast = $mdToast;
    }
    NotifyService.prototype.error = function (msg) {
        this.$mdToast.show(this.$mdToast.simple()
            .content(msg)
            .action('OK')
            .position('top right')
            .hideDelay(13000000)
            .theme('red'));
    };
    NotifyService.prototype.success = function (msg) {
        this.$mdToast.show(this.$mdToast.simple()
            .content(msg)
            .position('bottom left')
            .hideDelay(3000)
            .theme('green'));
    };
    NotifyService.$inject = ['$mdToast'];
    return NotifyService;
}());
;
angular
    .module('application')
    .service('notify', NotifyService);

//# sourceMappingURL=notify.js.map
